<template>
  <pc-dialog title="温馨提示" :visible.sync="dialogVisible" @close="close" @confirm="close">
    <template #content>
      <div class="tips">
        <span>{{ tips }}</span>
      </div>
    </template>
  </pc-dialog>
</template>

<script>
import PcDialog from '../dialog/Index.vue'

import { mapMutations } from 'vuex'

export default {
  name: 'PcTipsDialog',
  components: {
    PcDialog,
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    visible() {
      return this.$store.getters.tipsDialogVisible
    },
    tips() {
      return this.$store.getters.tips
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    ...mapMutations(['setTipsDialog']),
    close() {
      this.setTipsDialog({ visible: false })
    },
  }
}
</script>

<style lang="scss" scoped>
.tips {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 260px;
  font-size: 22px;
}
</style>